import classNames from 'classnames';
import { FormattedMessage } from 'components/shared/Intl';

type UnderlyingHistoModalButtonProps = {
  isMulti: boolean;
  isDisabled: boolean;
  onClick: () => void;
};

export function UnderlyingHistoModalButton({
  onClick,
  isMulti,
  isDisabled,
}: UnderlyingHistoModalButtonProps): React.JSX.Element {
  return (
    <button
      analytics-category="UnderlyingHisto"
      analytics-event="Underlying HistoGraph"
      analytics-on="click"
      disabled={isDisabled}
      className={classNames('btn btn-flat-secondary text-secondary', {
        'border-end btn-icon-end': isMulti,
        'btn-icon': !isMulti,
      })}
      onClick={onClick}
      type="button"
      data-e2e="underlying-histo-modal-btn"
    >
      {isMulti && <FormattedMessage id="underlying-btn-label" />}
      <i className="icon">insights</i>
    </button>
  );
}
